import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as AddBlack } from "../../../assets/addBlack.svg";
import Button from '../../Button/Button';
import LabelParameters from '../LabelParameters';
const Location = ({ parameterData, handleChange, editingInput, setEditingInput, setTypeLocation, setLocationState, locationParameter }) => {
  const [t] = useTranslation("Contacts");
  return (
    <>
      <LabelParameters value={parameterData.number} text={'textBox'} editingInput={editingInput} setEditingInput={setEditingInput} direction="column">
        <Button type="white" headerStyle={{ borderRadius: "999px" }} action={() => {
          setTypeLocation('parameter')
          setLocationState(true)
        }}>
          <AddBlack /> {t("addLocation")}
        </Button>
      </LabelParameters>
      {locationParameter?.email}
    </>
  )
}

export default Location